<div class="card">
	<div class="d-flex">
		<div class="display-12 ms-1 mt-2 mb-1">{{ jobRule.jobName }}</div>
		<div class="ms-auto">
			<fa-icon [icon]="['far', 'trash']" class="mx-4" size="xl" (click)="jobRuleDelete()"></fa-icon>
			<fa-icon *ngIf="!minimizeView" [icon]="['far', 'minimize']" class="mx-4" size="xl" (click)="minimizeView = true"></fa-icon>
			<fa-icon *ngIf="minimizeView" [icon]="['far', 'maximize']" class="mx-4" size="xl" (click)="minimizeView = false"></fa-icon>
		</div>
	</div>
	<ng-container *ngIf="!minimizeView">
		<p-divider></p-divider>

		<p-divider>
			<span class="display-14"> Weekly Overtime </span>
		</p-divider>
		<div class="p-grid">
			<div class="p-col-12 p-sm-4 d-flex">
				<div class="my-auto">Enabled</div>
				<div class="my-auto ms-4">
					<p-inputSwitch [(ngModel)]="jobRule.weeklyOvertime" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#weeklyOvertimeHoursInput
						[(ngModel)]="jobRule.weeklyOvertimeHours"
						suffix=" hrs"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.weeklyOvertime"
					></p-inputNumber>
					<label for="weeklyOvertimeHoursInput">Hours Threshold</label>
				</span>
			</div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#weeklyOvertimeRateInput
						[(ngModel)]="jobRule.weeklyOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.weeklyOvertime"
					></p-inputNumber>
					<label for="weeklyOvertimeRateInput">Pay Rate Multiplier</label>
				</span>
			</div>
		</div>

		<p-divider>
			<span class="display-14"> Daily Overtime </span>
		</p-divider>
		<div class="p-grid">
			<div class="p-col-12 p-sm-4 d-flex">
				<div class="my-auto">Enabled</div>
				<div class="my-auto ms-4">
					<p-inputSwitch [(ngModel)]="jobRule.dailyOvertime" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#dailyOvertimeHoursInput
						[(ngModel)]="jobRule.dailyOvertimeHours"
						suffix=" hrs"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.dailyOvertime"
					></p-inputNumber>
					<label for="dailyOvertimeHoursInput">Hours Threshold</label>
				</span>
			</div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#dailyOvertimeRateInput
						[(ngModel)]="jobRule.dailyOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.dailyOvertime"
					></p-inputNumber>
					<label for="dailyOvertimeRateInput">Pay Rate Multiplier</label>
				</span>
			</div>
		</div>

		<p-divider>
			<span class="display-14"> Daily Double Overtime </span>
		</p-divider>
		<div class="p-grid">
			<div class="p-col-12 p-sm-4 d-flex">
				<div class="my-auto">Enabled</div>
				<div class="my-auto ms-4">
					<p-inputSwitch [(ngModel)]="jobRule.dailyDoubleOvertime" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#dailyOvertimeHoursInput
						[(ngModel)]="jobRule.dailyDoubleOvertimeHours"
						suffix=" hrs"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.dailyDoubleOvertime"
					></p-inputNumber>
					<label for="dailyDoubleOvertimeHoursInput">Hours Threshold</label>
				</span>
			</div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#dailyOvertimeRateInput
						[(ngModel)]="jobRule.dailyDoubleOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.dailyDoubleOvertime"
					></p-inputNumber>
					<label for="dailyDoubleOvertimeRateInput">Pay Rate Multiplier</label>
				</span>
			</div>
		</div>

		<p-divider>
			<span class="display-14"> Sixth Day Overtime </span>
		</p-divider>
		<div class="p-grid">
			<div class="p-col-12 p-sm-4 d-flex">
				<div class="my-auto">Enabled</div>
				<div class="my-auto ms-4">
					<p-inputSwitch [(ngModel)]="jobRule.sixthDayOvertime" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
			<div class="p-col-12 p-sm-4"></div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#sixthDayOvertimeRateInput
						[(ngModel)]="jobRule.sixthDayOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.sixthDayOvertime"
					></p-inputNumber>
					<label for="sixthDayOvertimeRateInput">Pay Rate Multiplier</label>
				</span>
			</div>
		</div>

		<p-divider>
			<span class="display-14"> Seventh Day Overtime </span>
		</p-divider>
		<div class="p-grid">
			<div class="p-col-12 p-sm-4 d-flex">
				<div class="my-auto">Enabled</div>
				<div class="my-auto ms-4">
					<p-inputSwitch [(ngModel)]="jobRule.seventhDayOvertime" (ngModelChange)="changesToSave()"></p-inputSwitch>
				</div>
			</div>
			<div class="p-col-12 p-sm-4"></div>
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4 w-100">
					<p-inputNumber
						#seventhDayOvertimeRateInput
						[(ngModel)]="jobRule.seventhDayOvertimeRate"
						suffix="x"
						minFractionDigits="1"
						maxFractionDigits="1"
						inputStyleClass="text-right"
						styleClass="w-100"
						(ngModelChange)="changesToSave()"
						[disabled]="!jobRule.seventhDayOvertime"
					></p-inputNumber>
					<label for="seventhDayOvertimeRateInput">Pay Rate Multiplier</label>
				</span>
			</div>
		</div>
	</ng-container>
</div>
